/** 系统消息 type */
export const SYS_MSG_TYPE = {
  PERSONAL: 3000,
  BROADCAST: 4000
} as const

/** 系统消息 subType */
export const SYS_MSG_SUB_TYPE = {
  DEFAULT: 1
} as const

export interface MqttRpcUser {
  uid: number
  name?: string
  avatar?: string
}

export interface SysMsgAttachment {
  title?: string
  image?: string
  buttonText?: string
  /** 0-无跳转 1-跳转小类 2-跳转文库 3-H5 4-充值页 */
  jumpType?: number
  jumpUrl?: string
  jumpTargetId?: number
}

export interface SysMsgData {
  type: number
  subType: number
  msgId?: number
  fromUid?: number
  time?: number
  toUid?: number
  fromUser?: MqttRpcUser
  content?: string
  attachment?: SysMsgAttachment
}

export interface MqttEnvelope {
  action: string
  data?: SysMsgData
}

export interface SysMessageItem {
  id: string
  type: number
  subType: number
  title: string
  content: string
  image?: string
  buttonText?: string
  attachment?: SysMsgAttachment
  time?: number
  /** 本地收到时间 */
  receivedAt?: number
  /** 是否已读 */
  read?: boolean
}
